import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { get } from 'lodash'

import { Select } from 'components/fields'
import { Button } from 'components/misc'
import { modal } from 'redux/modules/app'
import { form } from 'helpers/decorators'
import { removeValidate } from 'models/contacts'
import { contactsOrganizationDropdownSelector } from 'redux/selectors/contacts'
import { AWARD_PAYMENT_STATES, REMOVE_CONTACT_TYPES } from 'constants/enums'

const enhance = compose(
  connect(null, { modal }),
  form({
    form: 'remove-contact-form',
    validate: removeValidate
  })
)

class ContactRemove extends Component {
  static propTypes = {
    onDelete: PropTypes.func.isRequired,
    selectContactFrom: PropTypes.array,
    onClose: PropTypes.func,
    modal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reasonsList: PropTypes.array,
    submitting: PropTypes.bool,
    values: PropTypes.object,
    id: PropTypes.number,
    awards: PropTypes.array,
    awardPaymentState: PropTypes.string,
    contactRemoveType: PropTypes.string
  }

  static defaultProps = {
    reasonsList: [],
    selectContactFrom: []
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose()
      return
    }

    this.props.modal(null)
  }

  getPaidAwards = awards => {
    return awards && awards.filter(a => get(a, 'paymentState.value') === AWARD_PAYMENT_STATES.PAID.id)
  }

  getTitle = contactRemoveType => {
    return (contactRemoveType === REMOVE_CONTACT_TYPES.PARTICIPANT_REGISTRATION.value) ?
        (<FormattedMessage
            id="participant.would_you_like_to_remove_registration"
            defaultMessage="Would you like to delete this registration?"
        />)
        :
        (<FormattedMessage
            id="participant.would_you_like_to_remove"
            defaultMessage="Would you like to delete this account?"
        />)
  }

  getWarning = contactRemoveType => {
    return (contactRemoveType === REMOVE_CONTACT_TYPES.PARTICIPANT_REGISTRATION.value) ?
        (<FormattedMessage
            id="warning.award_marked_as_paid_registration"
            defaultMessage="Warning: This Award registration is marked as paid.  Please refer to the payment and refund guidelines before confirming."
        />)
        :
        (<FormattedMessage
            id="warning.award_marked_as_paid"
            defaultMessage="Warning: There is at least one Award level or registration marked as paid.  Please refer to the payment and refund guidelines before confirming."
        />)
  }

  render() {
    const {
      id,
      reasonsList,
      handleSubmit,
      submitting,
      selectContactFrom,
      values,
      awards,
      awardPaymentState,
      contactRemoveType,
      orgContactId
    } = this.props

    const paidAwards = this.getPaidAwards(awards)

    const showWarningMsg = (paidAwards && paidAwards.length > 0) || awardPaymentState === AWARD_PAYMENT_STATES.PAID.id

    const mapSelectContactFromArray = contactsOrganizationDropdownSelector(
      selectContactFrom
    )

    const needToSelectIdFirst = Boolean(
      mapSelectContactFromArray.length > 0 && !id
    )

    const selectedOrgContactId = get(values, 'helpers.awardUnitId', id) || id

    return (
      <form
        onSubmit={handleSubmit(fields =>
          this.props.onDelete(selectedOrgContactId, fields)
        )}
      >
        <div className="row">
          <div className="col-xs-12">
            <h2 className="text--center">
              {this.getTitle(contactRemoveType)}
            </h2>
          </div>

          {showWarningMsg && <div className="col-xs-12" style={{ marginBottom: 10, color: '#d0021b' }}>
            {this.getWarning(contactRemoveType)}
          </div>}

          {needToSelectIdFirst &&
            <div className="col-xs-12">
              <Select
                name="helpers.awardUnitId"
                label="Select Award Unit"
                options={mapSelectContactFromArray}
              />
            </div>}

          {reasonsList.length > 0 &&
            <div className="col-xs-12">
              <Select
                name="reason"
                label="Reason of deletion"
                options={reasonsList}
                disabled={needToSelectIdFirst && !selectedOrgContactId}
              />
            </div>}
          <div className="col-xs-6">
            <Button type="button" onClick={this.handleClose} secondary>
              <FormattedMessage id="button.close" defaultMessage="Close" />
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              negative
              isLoading={submitting}
            >
              <FormattedMessage id="button.remove" defaultMessage="Remove" />
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default enhance(ContactRemove)
